/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmVyberovaSkupinaObsah extends GContentBase<SeznamAdmVyberovaSkupinaObsahObj> {
        private seznamObj: SeznamAdmVyberovaSkupinaObsahObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmVyberovaSkupinaObsahObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVyberovaSkupinaObsah",
                contentCaption: "jres:33000437", //RC 33000430 : V�b�rov� skupiny
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_blk} - {typ_subj_txt} - {nazev}"
                },
                gridSettings: {
                    columnOrder: "ixs_blk_txt,nazev,typ_subj_txt,poznamka,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmVyberovaSkupinaObsahObj extends GAdmSeznamBase {
        private ixs_blk: string;
        private srv: GContent;

        private getSrv() {
            if (this.srv == null || this.srv == undefined)
                this.srv = this.cnt.createServiceContent("Gordic.Adm.WebControls.SeznamAdmVyberovaSkupinaObsah");
            return this.srv;
        }


        create() {

        }

        openDetail(data: any, isNew: boolean) {
            this.getSrv().call("CreateLinkToObject", { data: data }).done((output: Gordic.Adm.WebControls.BaseDetailObj) => {
                var obj: any = {};
                output.paramsList?.forEach(item => {
                    if (item.key && item.value) 
                        obj[item.key] = item.value;
                })
                $.content().navigate([output.detailName, { currentFilter: null, gridRc: null }], obj).on("contentexception", (ev, exc,) => {
                    if (exc["errCode"]) {
                        if (exc["errCode"] == 21000023 && $.content(ev.target).className == "Gordic.Adm.WebControls.Detail") {   // Zru��m v�jimku pouze tohoto typu
                            exc["handled"] = true
                            this.cnt.dialogs.error("jres:32000124", "jres:33000452") //RC 33000452 : Nelze otev��t. Detail nen� dostupn�.
                        }
                    }
                })
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actRemoveFromDb: {
                    caption: "jres:33000454", //RC 33000454 : Odebrat z v�b�rov� skupiny
                    icon: "gi-bin",
                    tooltip: this.dataListDescription.data_right?.WriteReason,
                    enabled: (this.dataListDescription.data_right?.Write) ? this.dataListDescription.data_right?.Write : false,
                    run: (ev, ctx) => {
                        this.removeFromDb();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                "actAddToComparison*",
                "actRemoveFromDb*"
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actRemoveFromDb*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000432").addField("gselectbox", Gordic.Prefabs.Select.admWflsblk(), {
                dropdown: true,
                name: "ixs_blk",
                model: "model.ixs_blk=value.ixs_blk",
                disabled: (this.ixs_blk) ? true : false
            }).addRow("jres:30027522").addField("gselectbox", Gordic.Prefabs.Select.admWflctsu(), {
                dropdown: true,
                name: "typ_subj",
                model: "model.typ_subj=value.typ_subj",
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_blk)
                hardFilter["ixs_blk"] = this.ixs_blk;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_blk)
                data["ixs_blk"] = this.ixs_blk;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmVyberovaSkupinaObsah.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actRemoveFromDb?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.ixs_blk, data.typ_subj, data.sxs_subj),
                nazev: data.nazev
            }
        }

        private removeFromDb() {
            var sel = this.grid.ggrid("getSelection");
            if (sel.length > 0) {
                sel.forEach((item) => {
                    var data: Gordic.AdmIsl.Interface.GAdmVyberovaSkupinaObsahSaveDto = {};
                    data.ixs_blk = item.ixs_blk;
                    data.typ_subj = item.typ_subj;
                    data.sxs_subj = item.sxs_subj;
                    (this.cnt.isl.AdmVyberovaSkupinaObsah.delete({ data: data }).get() as any).done(() => {
                        this.view.updateData({ ixs_blk: data.ixs_blk, typ_subj: data.typ_subj, sxs_subj: data.sxs_subj }, "delete");
                        this.grid.ggrid("setData", this.view);
                    })
                })
               
            }
        }
    }
}